// extracted by mini-css-extract-plugin
module.exports = {"root":"Container_root__1UMcZ","smallRoot":"Container_smallRoot__23eqf"};